export default __webpack_public_path__ + "static/documentation-global-header-05-5babce13c4d7370bb61a4602e645298d.jpg";